import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { setShowPlansModal } from '../../../../store/one-query/chatsSlice'

const UpgradePlanButton = () => {
  const dispatch = useAppDispatch();
  const User = useAppSelector((s)=> s.User)

  const handleShowUpgradeToProModal = () => {
    dispatch(setShowPlansModal(true))
  };

  return (
    <div className="user-plan">   
      {!User.isSubscribed && 
        <div onClick={handleShowUpgradeToProModal}>
              <div className="upgradeBtn" >
                  <img src='/Images/GetConversations/upgrade-plan.svg' />
                  <span>Try Premium</span>
              </div>
        </div>
      }
    </div>
  )
}

export default UpgradePlanButton
